export default __webpack_public_path__ + "static/media/pindown2.fdc751c9.png";